import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import FilterCheckbox from './FilterCheckbox';
import ReportDownload from '../helpers/ReportDownload';
import DateRange from './DateRange';

const GroupCohortsGeneralFilter = ({
  meta,
  groups,
  csvReport,
  isLoading,
  onGroupChange,
  onColumnVisibilityChange,
  onWithCohortsChange,
  onCSVEnqueue,
  onCSVReportDetailsShow,
  periods,
  onPeriodChange,
}) => {
  return (
    <div>
      <div className='row u-margin-top--base u-margin-bottom--large align-middle'>
        { groups.length > 1 &&
          <div className='column small-12 medium-4 large-3 u-margin-top--base'>
            <Select
              name='sp-group-select'
              className={'o-select o-select--optgroup'}
              isMulti
              isClearable
              value={groups.filter(v => (meta.groups || '').split(',').map(i => parseInt(i)).includes(v.value))}
              onChange={(v) => onGroupChange(v.map(i => i.value).join(','))}
              options={groups}
              placeholder='All Groups'
              disabled={isLoading}
            />
          </div>
        }
        <div className='column shrink align-self-middle u-margin-top--base'>
          <FilterCheckbox
            label='With Subgroups and Cohorts'
            value={meta.withcohorts || false}
            onChange={onWithCohortsChange}
            disabled={isLoading}
          />
        </div>
        <div className='column shrink align-self-middle u-margin-top--base'>
          <FilterCheckbox
            label='With Age Ranges'
            value={meta.withages || false}
            onChange={onColumnVisibilityChange}
            disabled={isLoading}
          />
        </div>
        <div className='column small-12 medium-6 large-6 u--margin-bottom'>
          <DateRange
            startDate={meta.start}
            endDate={meta.end}
            onDatesChange={onPeriodChange}
            periods={periods}
            disabled={isLoading}
          />
        </div>
      </div>
      <div className='row u-margin-bottom--small'>
        <div className='column shrink'>
          <a onClick={onCSVEnqueue}>
            <i className='fa fa-file-excel-o fa' aria-hidden="true"></i> Generate CSV report
          </a>
        </div>
        <div className='column grow'>
          <ReportDownload report={csvReport} onReportDetailsShow={onCSVReportDetailsShow}/>
        </div>
      </div>
    </div>
  );
};

GroupCohortsGeneralFilter.propTypes = {
  meta: PropTypes.object.isRequired,
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  csvReport: PropTypes.object,
  withScope: PropTypes.object.isRequired,
  periods: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onColumnVisibilityChange: PropTypes.func.isRequired,
  onGroupChange: PropTypes.func.isRequired,
  onWithCohortsChange: PropTypes.func.isRequired,
  onCSVEnqueue: PropTypes.func.isRequired,
  onCSVReportDetailsShow: PropTypes.func.isRequired,
  onPeriodChange: PropTypes.func.isRequired,
}

export default GroupCohortsGeneralFilter;
